import {FC} from 'react';

import {getUserLocale, useAccount} from '@mavismart_frontend/stores/account_store';

interface DateTextProps {
  date: Date;
}

export const DateText: FC<DateTextProps> = ({date}) => {
  const account = useAccount();
  const locale = getUserLocale(account);

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  return <>{date.toLocaleString(locale, options)}</>;
};

DateText.displayName = 'DateText';
